import React, { Component } from 'react';
import { ModalBody, Modal } from "react-bootstrap";
import './PopBox.scss';

/*-- Imports for redux --*/
import { connect } from 'react-redux';
import { resetPopupBox } from '../../../redux/actions/popupBoxActions';

/*-- Map the redux states to props --*/
function mapStateToProps(state) {
    return {
        popupBox: state.popupBox
    }
};

/*-- Map the redux actions to props --*/
const mapDispatchToProps = {
    resetPopupBox
};

class PopupBox extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    };

    handleCallBackFunction(response) {
        if (this.props.popupBox.callBackFunction != null) {
            this.props.resetPopupBox();
            this.props.popupBox.callBackFunction(response);
        } else {
            this.props.resetPopupBox();
        }
    };

    render() {
        const theme = (this.props.popupBox.themeColor === undefined || this.props.popupBox.themeColor === "" || this.props.popupBox.themeColor === null)
            ? "" : this.props.popupBox.themeColor;
        return (
            <div>
                <Modal size="md" centered className="popup-box" show={this.props.popupBox.show === undefined ? false : this.props.popupBox.show}>
                    <ModalBody>
                        <div className="popup-background" style={{ backgroundImage: `url(${this.props.popupBox.imageURL})` }}>
                            <div className='popup-close-btn' style={{ background: theme }} onClick={() => { this.props.resetPopupBox(); }}>X</div>
                            <div class="input-group" onClick={() => { this.handleCallBackFunction(true) }}
                                style={{ display: (this.props.popupBox.isConfirmation && this.props.popupBox.buttonText1 !== "") ? "" : "none" }}>
                                <div class="btn-full">
                                    <button class="btn-inside popup-confirmation-btn" type="button">
                                        <span class="Popup-confirm-btn-text" style={{ color: theme }}>{this.props.popupBox.buttonText1}</span>
                                    </button>
                                    <div class="input-group-append">
                                        <div class="input-group-text append" style={{ background: theme }}>
                                            <i class="fas fa-angle-right"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="input-group" onClick={() => { this.handleCallBackFunction(false) }}
                                style={{ display: (this.props.popupBox.isConfirmation && this.props.popupBox.buttonText2 !== "") ? "" : "none" }}>
                                <div class="btn-full">
                                    <button class="btn-inside popup-confirmation-btn" type="button">
                                        <span class="Popup-confirm-btn-text" style={{ color: theme }}>{this.props.popupBox.buttonText2}</span>
                                    </button>
                                    <div class="input-group-append">
                                        <div class="input-group-text append" style={{ background: theme }}>
                                            <i class="fas fa-angle-right"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PopupBox);
